import React, { useEffect, useState, createContext, useContext } from 'react';
import { Job, JobContextType } from '../types';
const JobContext = createContext<JobContextType | undefined>(undefined);
// Mock jobs for demo - including completed jobs with costs, phone calls, and messages
const MOCK_JOBS: Job[] = [{
  id: '1',
  customerId: '1',
  customerName: 'John Smith',
  type: 'automotive',
  title: 'Classic Car Frame Restoration',
  description: 'Full frame sandblasting for 1967 Mustang restoration project. Heavy rust removal needed.',
  location: 'Austin, TX',
  urgency: 'standard',
  status: 'complete',
  media: [{
    id: 'm1',
    type: 'image',
    url: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=400&h=300&fit=crop'
  }],
  costs: [{
    id: 'c1',
    category: 'media',
    amount: 150,
    description: 'Aluminum oxide media - 200lbs',
    date: '2024-01-15'
  }, {
    id: 'c2',
    category: 'labor',
    amount: 320,
    description: '8 hours @ $40/hr',
    date: '2024-01-15'
  }, {
    id: 'c3',
    category: 'fuel',
    amount: 45,
    description: 'Compressor fuel',
    date: '2024-01-15'
  }],
  phoneCalls: [{
    id: 'call1',
    date: '2024-01-10T14:30:00Z',
    duration: 245,
    direction: 'inbound',
    recordingUrl: 'https://example.com/recording1.mp3',
    notes: 'Initial consultation about the project scope'
  }, {
    id: 'call2',
    date: '2024-01-12T10:15:00Z',
    duration: 180,
    direction: 'outbound',
    recordingUrl: 'https://example.com/recording2.mp3',
    notes: 'Follow-up on scheduling availability'
  }, {
    id: 'call3',
    date: '2024-01-15T16:45:00Z',
    duration: 120,
    direction: 'inbound',
    recordingUrl: 'https://example.com/recording3.mp3',
    notes: 'Customer called to confirm pickup time'
  }],
  messages: [{
    id: 'msg1',
    text: 'Hi! I wanted to check on the status of my Mustang frame',
    timestamp: '2024-01-14T10:00:00Z',
    isFromCustomer: true
  }, {
    id: 'msg2',
    text: "Hey John! We're scheduled to start on Monday morning. Should be done by end of day.",
    timestamp: '2024-01-14T10:05:00Z',
    isFromCustomer: false
  }, {
    id: 'msg3',
    text: 'Perfect! Do I need to bring anything?',
    timestamp: '2024-01-14T10:07:00Z',
    isFromCustomer: true
  }, {
    id: 'msg4',
    text: 'Nope, we have everything we need. Just make sure the frame is accessible.',
    timestamp: '2024-01-14T10:10:00Z',
    isFromCustomer: false
  }, {
    id: 'msg5',
    text: 'Got it, thanks!',
    timestamp: '2024-01-14T10:12:00Z',
    isFromCustomer: true
  }, {
    id: 'msg6',
    text: 'Just finished up! The frame came out great. Ready for pickup anytime after 5pm.',
    timestamp: '2024-01-15T16:45:00Z',
    isFromCustomer: false
  }, {
    id: 'msg7',
    text: "Awesome! I'll swing by around 6. Can't wait to see it!",
    timestamp: '2024-01-15T16:50:00Z',
    isFromCustomer: true
  }, {
    id: 'msg8',
    text: 'Thanks! The car looks amazing 🚗',
    timestamp: '2024-01-20T16:30:00Z',
    isFromCustomer: true
  }],
  revenue: 850,
  scheduledDate: '2024-01-15T09:00:00Z',
  completedDate: '2024-01-15T17:00:00Z',
  createdAt: '2024-01-10T10:00:00Z',
  updatedAt: '2024-01-15T17:00:00Z',
  notes: 'Customer very satisfied. Frame came out perfect.'
}, {
  id: '2',
  customerId: '1',
  customerName: 'John Smith',
  type: 'industrial',
  title: 'Metal Fabrication Parts',
  description: 'Clean 20 steel brackets before powder coating',
  location: 'Austin, TX',
  urgency: 'urgent',
  status: 'scheduled',
  media: [],
  costs: [],
  phoneCalls: [{
    id: 'call4',
    date: '2024-01-18T09:30:00Z',
    duration: 95,
    direction: 'inbound',
    recordingUrl: 'https://example.com/recording4.mp3',
    notes: 'Urgent request for quick turnaround'
  }],
  messages: [{
    id: 'msg9',
    text: 'Hey, I have 20 steel brackets that need cleaning before powder coating',
    timestamp: '2024-01-18T09:00:00Z',
    isFromCustomer: true
  }, {
    id: 'msg10',
    text: 'Sure thing! When do you need them by?',
    timestamp: '2024-01-18T09:05:00Z',
    isFromCustomer: false
  }, {
    id: 'msg11',
    text: 'This is kind of urgent - end of week if possible?',
    timestamp: '2024-01-18T09:10:00Z',
    isFromCustomer: true
  }, {
    id: 'msg12',
    text: "We can fit you in Monday. Drop them off in the morning and they'll be ready by 5pm.",
    timestamp: '2024-01-18T09:15:00Z',
    isFromCustomer: false
  }, {
    id: 'msg13',
    text: "Perfect! I'll bring them by around 8am",
    timestamp: '2024-01-18T09:20:00Z',
    isFromCustomer: true
  }],
  scheduledDate: '2024-01-22T10:00:00Z',
  createdAt: '2024-01-18T09:00:00Z',
  updatedAt: '2024-01-18T09:00:00Z'
}, {
  id: '3',
  customerId: '3',
  customerName: 'Mike Johnson',
  type: 'marine',
  title: 'Boat Hull Restoration',
  description: 'Remove old paint and rust from 24ft boat hull. Prepare for new coating.',
  location: 'Lake Travis, TX',
  urgency: 'standard',
  status: 'complete',
  media: [{
    id: 'm2',
    type: 'image',
    url: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&h=300&fit=crop'
  }],
  costs: [{
    id: 'c4',
    category: 'media',
    amount: 280,
    description: 'Garnet media - 400lbs',
    date: '2024-01-12'
  }, {
    id: 'c5',
    category: 'labor',
    amount: 640,
    description: '16 hours @ $40/hr',
    date: '2024-01-12'
  }, {
    id: 'c6',
    category: 'fuel',
    amount: 85,
    description: 'Compressor fuel',
    date: '2024-01-12'
  }, {
    id: 'c7',
    category: 'miscellaneous',
    amount: 120,
    description: 'Containment setup',
    date: '2024-01-12'
  }],
  phoneCalls: [{
    id: 'call5',
    date: '2024-01-08T11:00:00Z',
    duration: 420,
    direction: 'inbound',
    recordingUrl: 'https://example.com/recording5.mp3',
    notes: 'Detailed discussion about hull condition and timeline'
  }, {
    id: 'call6',
    date: '2024-01-11T15:20:00Z',
    duration: 150,
    direction: 'outbound',
    notes: 'Update on progress - no recording'
  }],
  messages: [{
    id: 'msg14',
    text: 'Hey, I have a 24ft boat hull that needs blasting. Can you handle that size?',
    timestamp: '2024-01-08T09:00:00Z',
    isFromCustomer: true
  }, {
    id: 'msg15',
    text: 'Absolutely! We do marine work all the time. Can you send some photos?',
    timestamp: '2024-01-08T09:15:00Z',
    isFromCustomer: false
  }, {
    id: 'msg16',
    text: 'Sure, sending now...',
    timestamp: '2024-01-08T09:20:00Z',
    isFromCustomer: true
  }, {
    id: 'msg17',
    text: 'Got them. Looks like a solid 2-day job. We can start Friday if that works?',
    timestamp: '2024-01-08T09:45:00Z',
    isFromCustomer: false
  }, {
    id: 'msg18',
    text: "Friday works great! What's the estimate?",
    timestamp: '2024-01-08T10:00:00Z',
    isFromCustomer: true
  }, {
    id: 'msg19',
    text: "I'll send over a detailed quote by end of day. Should be around $1,650.",
    timestamp: '2024-01-08T10:05:00Z',
    isFromCustomer: false
  }, {
    id: 'msg20',
    text: 'Sounds good, let me know!',
    timestamp: '2024-01-08T10:10:00Z',
    isFromCustomer: true
  }, {
    id: 'msg21',
    text: 'All done! Hull is ready for new coating. Looks brand new underneath.',
    timestamp: '2024-01-12T17:30:00Z',
    isFromCustomer: false
  }, {
    id: 'msg22',
    text: 'You guys are the best! 👍',
    timestamp: '2024-01-13T14:20:00Z',
    isFromCustomer: true
  }],
  revenue: 1650,
  scheduledDate: '2024-01-12T08:00:00Z',
  completedDate: '2024-01-12T18:00:00Z',
  createdAt: '2024-01-08T14:00:00Z',
  updatedAt: '2024-01-12T18:00:00Z',
  notes: 'Large job. Hull in great shape after blasting.'
}, {
  id: '4',
  customerId: '4',
  customerName: 'Sarah Williams',
  type: 'residential',
  title: 'Wrought Iron Fence Restoration',
  description: 'Remove rust and old paint from 50ft wrought iron fence',
  location: 'Round Rock, TX',
  urgency: 'standard',
  status: 'complete',
  media: [],
  costs: [{
    id: 'c8',
    category: 'media',
    amount: 95,
    description: 'Coal slag media - 150lbs',
    date: '2024-01-10'
  }, {
    id: 'c9',
    category: 'labor',
    amount: 240,
    description: '6 hours @ $40/hr',
    date: '2024-01-10'
  }, {
    id: 'c10',
    category: 'fuel',
    amount: 35,
    description: 'Compressor fuel',
    date: '2024-01-10'
  }],
  phoneCalls: [],
  messages: [{
    id: 'msg23',
    text: "Hi! I need my wrought iron fence restored. It's pretty rusty.",
    timestamp: '2024-01-05T13:00:00Z',
    isFromCustomer: true
  }, {
    id: 'msg24',
    text: 'We can definitely help with that! How many feet of fencing?',
    timestamp: '2024-01-05T13:20:00Z',
    isFromCustomer: false
  }, {
    id: 'msg25',
    text: 'About 50 feet total',
    timestamp: '2024-01-05T13:25:00Z',
    isFromCustomer: true
  }, {
    id: 'msg26',
    text: 'Perfect size for a day job. We can come out Wednesday to take a look.',
    timestamp: '2024-01-05T13:30:00Z',
    isFromCustomer: false
  }, {
    id: 'msg27',
    text: 'Wednesday works! What time?',
    timestamp: '2024-01-05T13:35:00Z',
    isFromCustomer: true
  }, {
    id: 'msg28',
    text: 'How about 9am? Should take about 6 hours total.',
    timestamp: '2024-01-05T13:40:00Z',
    isFromCustomer: false
  }, {
    id: 'msg29',
    text: 'See you then!',
    timestamp: '2024-01-05T13:45:00Z',
    isFromCustomer: true
  }, {
    id: 'msg30',
    text: 'The fence looks incredible!',
    timestamp: '2024-01-11T11:00:00Z',
    isFromCustomer: true
  }],
  revenue: 550,
  scheduledDate: '2024-01-10T09:00:00Z',
  completedDate: '2024-01-10T15:00:00Z',
  createdAt: '2024-01-05T11:00:00Z',
  updatedAt: '2024-01-10T15:00:00Z'
}, {
  id: '5',
  customerId: '5',
  customerName: 'David Chen',
  type: 'industrial',
  title: 'Heavy Equipment Parts',
  description: 'Blast 8 large machinery components for refurbishment',
  location: 'Georgetown, TX',
  urgency: 'urgent',
  status: 'complete',
  media: [{
    id: 'm3',
    type: 'image',
    url: 'https://images.unsplash.com/photo-1581094271901-8022df4466f9?w=400&h=300&fit=crop'
  }],
  costs: [{
    id: 'c11',
    category: 'media',
    amount: 340,
    description: 'Steel grit media - 500lbs',
    date: '2024-01-08'
  }, {
    id: 'c12',
    category: 'labor',
    amount: 480,
    description: '12 hours @ $40/hr',
    date: '2024-01-08'
  }, {
    id: 'c13',
    category: 'fuel',
    amount: 95,
    description: 'Compressor fuel',
    date: '2024-01-08'
  }, {
    id: 'c14',
    category: 'parts',
    amount: 75,
    description: 'Replacement nozzles',
    date: '2024-01-08'
  }],
  phoneCalls: [{
    id: 'call7',
    date: '2024-01-03T13:45:00Z',
    duration: 310,
    direction: 'inbound',
    recordingUrl: 'https://example.com/recording7.mp3',
    notes: 'Discussion about equipment requirements and safety protocols'
  }],
  messages: [{
    id: 'msg31',
    text: 'Need 8 heavy equipment parts blasted ASAP. Can you prioritize?',
    timestamp: '2024-01-03T14:00:00Z',
    isFromCustomer: true
  }, {
    id: 'msg32',
    text: "We can fast-track this. What's the timeline?",
    timestamp: '2024-01-03T14:10:00Z',
    isFromCustomer: false
  }, {
    id: 'msg33',
    text: 'Need them by end of week for a big project',
    timestamp: '2024-01-03T14:15:00Z',
    isFromCustomer: true
  }, {
    id: 'msg34',
    text: "We can do Monday. These are large parts so we'll need the full day.",
    timestamp: '2024-01-03T14:20:00Z',
    isFromCustomer: false
  }, {
    id: 'msg35',
    text: 'That works! What equipment do you need from us?',
    timestamp: '2024-01-03T14:25:00Z',
    isFromCustomer: true
  }, {
    id: 'msg36',
    text: "Just need a forklift on site to move the parts. We'll bring everything else.",
    timestamp: '2024-01-03T14:30:00Z',
    isFromCustomer: false
  }, {
    id: 'msg37',
    text: 'Done. Forklift will be ready.',
    timestamp: '2024-01-03T14:35:00Z',
    isFromCustomer: true
  }, {
    id: 'msg38',
    text: 'All 8 parts completed! They came out great. Sending invoice now.',
    timestamp: '2024-01-08T18:00:00Z',
    isFromCustomer: false
  }, {
    id: 'msg39',
    text: 'Invoice received, processing payment now',
    timestamp: '2024-01-09T15:30:00Z',
    isFromCustomer: true
  }],
  revenue: 1450,
  scheduledDate: '2024-01-08T07:00:00Z',
  completedDate: '2024-01-08T19:00:00Z',
  createdAt: '2024-01-03T16:00:00Z',
  updatedAt: '2024-01-08T19:00:00Z',
  notes: 'Heavy duty job. Required specialized equipment.'
}, {
  id: '6',
  customerId: '1',
  customerName: 'John Smith',
  type: 'automotive',
  title: 'Motorcycle Parts Cleaning',
  description: 'Clean and prep motorcycle frame and parts for paint',
  location: 'Austin, TX',
  urgency: 'standard',
  status: 'in-progress',
  media: [],
  costs: [{
    id: 'c15',
    category: 'media',
    amount: 65,
    description: 'Glass bead media - 100lbs',
    date: '2024-01-20'
  }],
  phoneCalls: [{
    id: 'call8',
    date: '2024-01-16T10:30:00Z',
    duration: 135,
    direction: 'outbound',
    recordingUrl: 'https://example.com/recording8.mp3',
    notes: 'Confirmed parts are ready for pickup'
  }],
  messages: [{
    id: 'msg40',
    text: 'Do you do motorcycle parts?',
    timestamp: '2024-01-16T11:00:00Z',
    isFromCustomer: true
  }, {
    id: 'msg41',
    text: 'Yes! We do a lot of motorcycle work. What parts?',
    timestamp: '2024-01-16T11:10:00Z',
    isFromCustomer: false
  }, {
    id: 'msg42',
    text: 'Frame, swingarm, and a few smaller brackets',
    timestamp: '2024-01-16T11:15:00Z',
    isFromCustomer: true
  }, {
    id: 'msg43',
    text: "Nice! We'll use glass bead for a smooth finish. $285 total.",
    timestamp: '2024-01-16T11:20:00Z',
    isFromCustomer: false
  }, {
    id: 'msg44',
    text: 'Great! How long will it take?',
    timestamp: '2024-01-16T11:25:00Z',
    isFromCustomer: true
  }, {
    id: 'msg45',
    text: 'Usually 2-3 days turnaround. Can start Monday if you drop off then.',
    timestamp: '2024-01-16T11:30:00Z',
    isFromCustomer: false
  }, {
    id: 'msg46',
    text: "Sounds good, I'll drop them off Monday",
    timestamp: '2024-01-17T14:00:00Z',
    isFromCustomer: true
  }],
  scheduledDate: '2024-01-20T10:00:00Z',
  createdAt: '2024-01-16T13:00:00Z',
  updatedAt: '2024-01-20T10:00:00Z'
}];
export function JobProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [jobs, setJobs] = useState<Job[]>([]);
  useEffect(() => {
    const savedJobs = localStorage.getItem('merem_jobs');
    if (savedJobs) {
      setJobs(JSON.parse(savedJobs));
    } else {
      setJobs(MOCK_JOBS);
      localStorage.setItem('merem_jobs', JSON.stringify(MOCK_JOBS));
    }
  }, []);
  const saveJobs = (updatedJobs: Job[]) => {
    setJobs(updatedJobs);
    localStorage.setItem('merem_jobs', JSON.stringify(updatedJobs));
  };
  const addJob = (jobData: Omit<Job, 'id' | 'createdAt' | 'updatedAt'>) => {
    const newJob: Job = {
      ...jobData,
      id: Date.now().toString(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    saveJobs([...jobs, newJob]);
  };
  const updateJob = (id: string, updates: Partial<Job>) => {
    const updatedJobs = jobs.map(job => job.id === id ? {
      ...job,
      ...updates,
      updatedAt: new Date().toISOString()
    } : job);
    saveJobs(updatedJobs);
  };
  const deleteJob = (id: string) => {
    saveJobs(jobs.filter(job => job.id !== id));
  };
  const getJobById = (id: string) => jobs.find(job => job.id === id);
  const getJobsByCustomer = (customerId: string) => jobs.filter(job => job.customerId === customerId);
  return <JobContext.Provider value={{
    jobs,
    addJob,
    updateJob,
    deleteJob,
    getJobById,
    getJobsByCustomer
  }} data-id="element-182">
      {children}
    </JobContext.Provider>;
}
export function useJobs() {
  const context = useContext(JobContext);
  if (!context) {
    throw new Error('useJobs must be used within JobProvider');
  }
  return context;
}